import { render, staticRenderFns } from "./MessagesMain.vue?vue&type=template&id=1aea4b59"
import script from "./MessagesMain.vue?vue&type=script&lang=js"
export * from "./MessagesMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports